/**
 * Created by Administrator on 2018/7/3.
 */
export default [
  {
    path: '/smart',
    component: () => import('../pages/smart/index'),
    children: [
      {
        path: 'bodyImg',
        meta: {
          title: '智能导诊'
        },
        component: () => import('../pages/smart/bodyImg')
      },
      {
        path: 'bodyList',
        meta: {
          title: '智能导诊'
        },
        component: () => import('../pages/smart/bodyList')
      }
    ]
  },
  {
    path: '/symptom',
    meta: {
      title: '智能导诊'
    },
    component: () => import('../pages/smart/symptom')
  },
  {
    path: '/sympDetail',
    meta: {
      title: '智能导诊'
    },
    component: () => import('../pages/smart/sympDetail')
  },
  {
    path: '/room',
    component: () => import('../pages/smart/room')
  },
  {
    path: '/recommendRoom',
    meta: {
      title: '智能导诊'
    },
    component: () => import('../pages/smart/recommendRoom')
  },
  {
    path: '/age',
    meta: {
      title: '智能导诊'
    },
    component: () => import('../pages/smart/age')
  },
  {
    path: '/zuoshou',
    meta: {
      title: '智能诊断'
    },
    component: () => import('../pages/smart/zuoshou')
  }
]



// WEBPACK FOOTER //
// ./src/router/smart.js